// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cv-option,
.cv-option-created {
  padding: 8px;
  cursor: pointer;
  margin-bottom: 5px;
}

.cv-option-created {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.custom-view-scroll {
  max-height: 240px;
  overflow-y: auto;
}

@media (min-width: 1024px) {
  .custom-view-scroll {
    max-height: 250px;
    overflow-y: auto;
  }
}
@media (min-width: 1366px) {
  .custom-view-scroll {
    max-height: 400px;
    overflow-y: auto;
  }
}
@media (min-width: 1920px) {
  .custom-view-scroll {
    max-height: 500px;
    overflow-y: auto;
  }
}`, "",{"version":3,"sources":["webpack://./../report/src/components/UniversalReport/components/LeftSideBarCustomViewCanvas.scss"],"names":[],"mappings":"AAAA;;EAEE,YAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE;IACE,iBAAA;IACA,gBAAA;EACF;AACF;AAEA;EACE;IACE,iBAAA;IACA,gBAAA;EAAF;AACF;AAGA;EACE;IACE,iBAAA;IACA,gBAAA;EADF;AACF","sourcesContent":[".cv-option,\n.cv-option-created {\n  padding: 8px;\n  cursor: pointer;\n  margin-bottom: 5px;\n}\n\n.cv-option-created {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.custom-view-scroll {\n  max-height: 240px;\n  overflow-y: auto;\n}\n\n@media (min-width: 1024px) {\n  .custom-view-scroll {\n    max-height: 250px;\n    overflow-y: auto;\n  }\n}\n\n@media (min-width: 1366px) {\n  .custom-view-scroll {\n    max-height: 400px;\n    overflow-y: auto;\n  }\n}\n\n@media (min-width: 1920px) {\n  .custom-view-scroll {\n    max-height: 500px;\n    overflow-y: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
